import React, { useCallback } from "react";
import { Button, Grid, Header, Icon, Input, Modal } from "semantic-ui-react";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { socket } from "../../../../lib/socketio";
import Footer from "../../Footer";
import ClearOverride from "../../../Macros/ClearOverride";
import ActivateOverride from "../../../Macros/ActivateOverride";
import {
  Filter,
  HEX_SOFC,
  Heater,
} from "../../../Definitions/GraphicComponents";
import { setCurrentPLC, setUserArray } from "../../../../actions/headerActions";
import { setUser } from "../../../../actions/navActions";
import RequestAccessModal from "../../../RequestAccess/RequestAccessModal";
import { GRAPHICS_WRITE, isAuthorized } from "../../../../lib/authorization";

const CVSOvr_S300_PSM1 = () => {
  const [tags, settags] = React.useState([]);
  const [data, setData] = React.useState([]);
  const [anovrdata, setAnOvrdata] = React.useState([]);
  const [digovrdata, setDigOvrdata] = React.useState([]);
  const [tempoverridden, settempoverriden] = React.useState({});
  const [tempovrdata, settempovrdata] = React.useState({});
  const [tempovrdigdata, settempovrdigdata] = React.useState({});
  const [tagdata, settagdata] = React.useState("");
  const [open, setOpen] = React.useState(false);
  const [overrideVisible, setOverrideVisible] = React.useState({
    visible: true,
  });
  const [dataCopy, setDataCopy] = React.useState();
  const [checkdata, setcheckdata] = React.useState("");
  const location = useLocation();
  const user = useSelector((state) => state.nav.user);
  const userCopy = useSelector((state) => state.nav.userCopy);
  const electronApp = useSelector((state) => state.nav.electronApp);
  const currentPLC = useSelector((state) => state.header.currentPLC);
  const [userArr, setUserArr] = React.useState(null);
  const [requestor, setRequestor] = React.useState(null);
  const [pop, setPop] = React.useState(false);
  const dispatch = useDispatch();

  React.useEffect(() => {
    dispatch(setCurrentPLC(location.pathname.slice(-4)));
  }, []);

  React.useEffect(() => {
    socket.emit("get tag names", [
      { display_id: 70 },
      { display_id: 67 }
    ]);
    socket.on("receive tag names", (data) => {
      const isFound = data.tags_data.some(
        (element) => element.display_id === 70
      );
      if (isFound) {
        settags(data.tags_data);
      }
    });
    return () => {
      socket.removeAllListeners();
    };
  }, [tags]);

  const ids = tags.map((t) => t.id);
  const FooterTags = tags.flatMap((t) => (t.display_id === 67 ? [t] : []));

  const GenTags = tags.flatMap((t) =>
    t.display_id === 70 || t.display_id === 4 ? [t] : [],
  );

  const display = GenTags.map((t) => t.page_name);

  const SysDigTags = GenTags.flatMap((t) =>
    t.name.slice(5, 8) === "DIN" || t.name.slice(5, 9) === "DOUT" ? [t] : [],
  );

  const SysAnTags = GenTags.flatMap((t) =>
    t.name.slice(5, 8) === "AIN" || t.name.slice(5, 9) === "AOUT" ? [t] : [],
  );

  const ClearDigIds = SysDigTags.map((t) => t.id);
  const ClearAnIds = SysAnTags.map((t) => t.id);

  React.useEffect(() => {
    if (!electronApp) {
      var currentClient = `${user.name}:${socket.id}:${userCopy.hmi_role}`;
      socket.on("userDict", (response) => {
        let res = response[currentPLC];

        if (res.indexOf(currentClient) === 1) {
          if (userCopy.hmi_role !== user.hmi_role) {
            user.hmi_role = userCopy.hmi_role;
            dispatch(setUser(user));
          }
        } else {
          dispatch(setUserArray(response));

          for (var i = 2; i < res.length; i++) {
            var info = res[i].split(":");
            if (user.name === info[0]) {
              user.hmi_role = "E";
              setUser(user);
            }
          }
        }
      });
      socket.on("permission", (data) => {
        setUserArr(data.mainArr); // local variable
        setRequestor(data.requestor);
        setPop(true);
      });
      socket.on("access granted", (response) => {
        let data = response[currentPLC];
        if (data.indexOf(currentClient) === 1) {
          user.hmi_role = userCopy.hmi_role;
          dispatch(setUser(user));
        } else {
          dispatch(setUserArray(response));
          user.hmi_role = "E";
          dispatch(setUser(user));
        }
      });
      socket.on("access denied", () => {
        alert("ACCESS DENIED");
      });
      socket.on("access transferred", (data) => {
        alert(
          `Access has been tranferred to ${data.requested.split(":")[0]}. Comment: ${data.comment}`,
        );
      });
    }
    if (ids.length > 0) {
      socket.emit("get tag values", ids);
      socket.on("receive tag values", (value) => {
        setData(value.result);
      });

      return () => {
        socket.removeAllListeners();
      };
    }
  }, [ids, data]);

  React.useEffect(() => {
    let interval = setInterval(setOverrideVisiblity, 400);
    return () => clearInterval(interval);
  }, [overrideVisible]); // eslint-disable-line react-hooks/exhaustive-deps

  const rsstags = [];
  let rows;
  const length = GenTags.length;
  rows = Math.round(length / 3) + 1;
  let i = 0;
  while (i < length) {
    rsstags.push(GenTags.slice(i, i + rows));
    i += rows;
  }

  const parentcallbackAn = useCallback((flag) => {
    if (flag === true) {
      setAnOvrdata([]);
      // setIsCopied(false);
      settags([]);
      settags([]);
    }
  }, []);

  const parentcallbackDig = useCallback((flag) => {
    if (flag === true) {
      setDigOvrdata([]);
      // setIsCopied(false);
      settags([]);
      setDataCopy({});
      settags([]);
    }
  }, []);

  const setOverrideVisiblity = () => {
    setOverrideVisible({
      ...overrideVisible,
      visible: !overrideVisible.visible,
    });
  };

  const grid = (tag_id) => (
    <Grid stretched style={{ height: "100%" }}>
      <Grid.Row style={{ marginBottom: "0px", paddingBottom: "0px" }}>
        <Grid.Column width={5} style={styles.name}>
          {typeof data !== "undefined" &&
          data[tag_id] !== null &&
          typeof data[tag_id] !== "undefined"
            ? tag_id === 7165
              ? data[tag_id].toFixed(3)
              : data[tag_id].toFixed(2)
            : ""}
        </Grid.Column>
        <Grid.Column width={7} style={styles.gridUnit}>
          {typeof tags !== "undefined" &&
          tags !== null &&
          tags.length > 0 &&
          tags.findIndex((x) => x.id === tag_id) !== -1
            ? tag_id === 5276 || tag_id === 5518 || tag_id === 5531
              ? "SP"
              : tags[tags.findIndex((x) => x.id === tag_id)].unit
            : ""}
        </Grid.Column>
      </Grid.Row>
      <Grid.Row style={{ paddingTop: "0px", marginTop: "0px" }}>
        <Grid.Column
          style={{
            color: "grey",
            fontSize: "15px",
            fontWeight: "bold",
            marginTop: "0px",
            paddingTop: "0px",
          }}
        >
          {typeof tags !== "undefined" &&
          tags !== null &&
          tags.length > 0 &&
          tags.findIndex((x) => x.id === tag_id) !== -1
            ? tags[tags.findIndex((x) => x.id === tag_id)].tag_display_name
            : ""}
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );

  const handleYes = () => {
    socket.emit("grant access", {
      message: "YES",
      requestor: requestor,
      mainArr: userArr,
      plc: currentPLC,
    });
    setPop(false);
  };
  const handleNo = () => {
    socket.emit("grant access", {
      message: "NO",
      requestor: requestor,
      mainArr: userArr,
      plc: currentPLC,
    });
    setPop(false);
  };

  return (
    <div style={styles.div}>
      {!electronApp && pop && (
        <RequestAccessModal
          pop={pop}
          yes={handleYes}
          no={handleNo}
          reqq={requestor.split(":")[0]}
        />
      )}
      <div style={styles.innerdiv}>
        <div style={{ float: "left" }}>
          {(electronApp || isAuthorized(user.hmi_role, GRAPHICS_WRITE)) && (
            <div style={styles.menu}>
              <ClearOverride
                tagid={ClearAnIds}
                tags={tags}
                settags={settags}
                option={3}
                title={"CLEAR ALL PSM1 ANALOG OVERRIDES"}
                channel={"Clear All PSM1 Analog Overrides"}
                settempovrdata={settempovrdata}
                settempoverriden={settempoverriden}
                parentCallback={parentcallbackAn}
              />
              <ActivateOverride
                ovrdata={anovrdata}
                tags={tags}
                settags={settags}
                option={2}
                title={"ACTIVATE ALL PSM1 ANALOG OVERRIDES"}
                channel={"Activate All PSM1 Analog Overrides"}
                parentCallback={parentcallbackAn}
                tempovrdata={tempovrdata}
                settempovrdata={settempovrdata}
                tempoverridden={tempoverridden}
                settempoverriden={settempoverriden}
              />
            </div>
          )}
        </div>
        <div style={{ float: "right" }}>
          {(electronApp || isAuthorized(user.hmi_role, GRAPHICS_WRITE)) && (
            <div style={styles.menu}>
              <ClearOverride
                tagid={ClearDigIds}
                tags={tags}
                settags={settags}
                option={3}
                title={"CLEAR ALL PDM1 DIGITAL OVERRIDES"}
                channel={"Clear All PSM1 Digital Overrides"}
                settempovrdata={settempovrdata}
                settempoverriden={settempoverriden}
                parentCallback={parentcallbackDig}
              />
              <ActivateOverride
                ovrdata={digovrdata}
                tags={tags}
                settags={settags}
                option={2}
                title={"ACTIVATE ALL PSM1 DIGITAL OVERRIDES"}
                channel={"Activate All PSM1 Digital Overrides"}
                parentCallback={parentcallbackDig}
                tempovrdata={tempovrdigdata}
                settempovrdata={settempovrdigdata}
                tempoverridden={tempoverridden}
                settempoverriden={settempoverriden}
              />
            </div>
          )}
        </div>
        <div style={{ float: "left", marginLeft: "13%" }}>
          <h2 style={styles.header}>CVS Overview : PSM1 </h2>
        </div>
        <div style={styles.div}>
          <svg width="2000" height="700">
            <Filter rect={{ x: 1060, y: 605 }} text="FLTR170" /> {/* FLTR170 */}
            <Heater rect={{ x: 1150, y: 485 }} text="HTR170" />
            <text
              x={1100}
              y={680}
              font-size={17}
              dominant-baseline="middle"
              text-anchor="middle"
              fill="#00B050"
            >
              AIR IN
            </text>{" "}
            {/* PSM AIR IN */}
            <path
              d="M 1100, 660 L 1100, 636 "
              stroke="green"
              strokeWidth={4}
              fill="none"
            />{" "}
            {/* OUTSIDE AIR to FLTR170 */}
            <path
              d="M 1100, 605 L 1100, 463 L 1100, 417 L 1100, 70 L 1110, 80 L 1100, 80  "
              stroke="green"
              strokeWidth={4}
              fill="none"
            />{" "}
            {/* FAN171 to FAN170 */}
            <path
              stroke-dasharray="5,5"
              d="M 950, 110 L 1350, 110 L 1350, 600 L 950, 600 L 950, 110"
              stroke="#00B050"
              strokeWidth={1}
              fill="none"
            />{" "}
            {/* outline */}
            <path
              stroke-dasharray="5,5"
              d="M 950, 480 L 1250, 480 L 1250, 350 L 950, 350"
              stroke="#00B050"
              strokeWidth={1}
              fill="none"
            />{" "}
            {/* outline */}
            {/* <path stroke-dasharray="5,5" d="M 1350, 110 L 1350, 600" stroke="#00B050" strokeWidth={1} fill='none'/> center line */}
            <path
              d="M 1260, 500 L 1260, 270 L 1103, 270 L 1113, 260 L 1113, 270"
              stroke="green"
              strokeWidth={4}
              fill="none"
            />{" "}
            {/* TO BLO110 to FAN170*/}
            <path
              d="M 1100, 500 L 1260, 500"
              stroke="green"
              strokeWidth={4}
              fill="none"
            />{" "}
            {/* TO BLO110 to FAN170*/}
            <text
              x={1280}
              y={130}
              font-size={17}
              dominant-baseline="middle"
              text-anchor="middle"
              fill="white"
            >
              COLD ZONE
            </text>
            {/* <text x={1600} y={130} font-size={17} dominant-baseline="middle" text-anchor="middle" fill='white'>STACK ZONE</text> */}
            {/* <Filter rect={{x:350, y:605}} text='FLTR180' /> FLTR180
                        <path stroke-dasharray="5,5" d="M 350, 110 L 750, 110 L 750, 600 L 350, 600 L 350, 110" stroke="#00B050" strokeWidth={1} fill='none'/> {/* outline */}
            {/* <text x={390} y={680} font-size={17} dominant-baseline="middle" text-anchor="middle" fill='#00B050'>AIR IN</text>
                        <path d="M 390, 660 L 390, 636" stroke="green" strokeWidth={4} fill='none'/> {/* OUTSIDE Air to FLTR180 */}
            {/* <path d="M 390, 603 L 390, 70 L 400, 80  L 390, 80" stroke="green" strokeWidth={4} fill='none'/> FLTR180 to HEX550 */}
            {/* <text x={690} y={130} font-size={17} dominant-baseline="middle" text-anchor="middle" fill='white'>CBM</text>  */}
            {/* <Filter rect={{x:1400, y:605}} text='FLTR190' /> FLTR180
                        <text x={1440} y={680} font-size={17} dominant-baseline="middle" text-anchor="middle" fill='#00B050'>AIR IN</text>
                        <path d="M 1440, 660 L 1440, 636" stroke="green" strokeWidth={4} fill='none'/> {/* OUTSIDE Air to FLTR190 */}
            {/* <path d="M 1440, 605 L 1440, 250 L 1550, 250 L 1550, 70 L 1560, 80 L 1550, 80" stroke="green" strokeWidth={4} fill='none'/> OUTSIDE Air to FLTR190 */}
            <foreignObject x={970} y={155} width={180} height={80}>
              <div style={{ height: "100%" }}>
                {grid(7744)} {/**TE170 */}
              </div>
            </foreignObject>
            <foreignObject x={970} y={270} width={180} height={80}>
              <div style={{ height: "100%" }}>
                {grid(7751)} {/**TE171 */}
              </div>
            </foreignObject>
            <foreignObject x={1270} y={275} width={180} height={80}>
              <div style={{ height: "100%" }}>
                {grid(6808)} {/**AT170 */}
              </div>
            </foreignObject>
            {/* <foreignObject x={410} y = {220} width={180} height={80}>
                            <div style={{height: '100%'}}>
                                {grid(508)} 
                            </div>
                        </foreignObject>
                        <foreignObject x={405} y = {280} width={120} height={80}>
                            <div style={{height: '100%'}}>
                                {grid_d(2136)} 
                            </div>
                        </foreignObject>
                        <foreignObject x={410} y = {340} width={120} height={80}>
                            <div style={{height: '100%'}}>
                                {grid(4)} 
                            </div>
                        </foreignObject> */}
            {/* <foreignObject x={1450} y = {260} width={120} height={80}>
                            <div style={{height: '100%'}}>
                                {grid(512)} 
                            </div>
                        </foreignObject>
                        <foreignObject x={1550} y = {260} width={120} height={80}>
                            <div style={{height: '100%'}}>
                                {grid(517)} 
                            </div>
                        </foreignObject> */}
          </svg>
        </div>
      </div>

      <Footer tags={FooterTags} data={data} />
    </div>
  );
};

const styles = {
  div: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    flex: "1 1 auto",
    width: "100%",
  },
  toggle: {
    marginLeft: "8px",
    marginTop: "0px",
  },
  grid: {
    marginTop: "5px",
  },
  name: {
    fontSize: "16px",
    fontWeight: "bold",
  },
  unit: {
    color: "#04BFBF",
    fontWeight: "bold",
    fontSize: "16px",
  },
  gridUnit: {
    color: "#04BFBF",
    fontWeight: "bold",
    fontSize: "16px",
    paddingLeft: "5px",
  },
  row: {
    paddingTop: "0px",
    marginBottom: "0px",
    paddingBottom: "0px",
  },
  width: {
    maxWidth: "300px",
  },
  innerdiv: {
    alignItems: "center",
    flex: "1 1 auto",
    paddingBottom: "0px",
    width: "100%",
  },
  menu: {
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "space-between",
    paddingBottom: "0px",
    paddingLeft: "15px",
    paddingRight: "15px",
  },
};

export default CVSOvr_S300_PSM1;
